import React, { useEffect, useRef, useState } from "react";
import Header from "../../../components/global/Header";
import LeftNavbar from "../../../components/global/LeftNavbar";
import { useTranslation } from "react-i18next";
import { getAxiosResponse, postAxiosResponse } from "../../../services/authApiRoutes/APImethods";
import APIUrls from "../../../services/APIUrls";
import { useNavigate } from "react-router-dom";
import $, { event } from "jquery";
import Select, { NonceProvider } from "react-select";
import { Breadcrumb } from "../../../components/dashboard/Breadcrumb";
import SuccessMessage from "../../../components/SuccessMessage";
import Constants from "../../../Constants";
import { CrossIcon } from "../../../AppIcons";

export default function ProjectSettingLanguage() {
  const scrollRef = useRef(null);
  const { t } = useTranslation();
  const translate = t;
  const [sourceLanguages, setSourceLanguages] = useState([]);
  const [selectedSourceLanguage, setSelectedSourceLanguage] = useState([]);
  const [defaultSelectedSourceLanguages, setDefaultSelectedSourceLanguages] =
    useState([]);
  const [targetLanguages, setTargetLanguages] = useState([]);
  const [selectedTargetLanguage, setSelectedTargetLanguage] = useState([]);
  const [defaultSelectedTargetLanguages, setDefaultSelectedTargetLanguages] =
    useState([]);
  const [allLanguages, setAllLanguages] = useState([]);
  const navigate = useNavigate();
  const [successMessage, setSuccessMessage] = useState("");

  useEffect(() => {
    if (successMessage !== Constants.BLANK) {
      setTimeout(function () {
        setSuccessMessage(Constants.BLANK);
      }, 5000);
    } else if (successMessage === Constants.BLANK) {
      setTimeout(function () {
        $('.lastdisable').trigger('focus');
      }, 300);
    }
  }, [successMessage]);
  
  const getData = () =>{
    var allLangArray = [];
    getAxiosResponse(APIUrls.GET_ALL_LANGUAGES)
      .then((res) => {
        if (res.data !== "") {
          res.data.data.map((langs) => {
            allLangArray.push({
              label: langs.display,
              value: langs.code,
              language: langs,
            });
          });
          setAllLanguages(res.data.data);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  useEffect(() => {
    getData()
  }, []);

  useEffect(() => {
    var defaultSelectedSourceLangArray = [];
    var selectedSourceLangArray = [];
    var defaultSelectedTargetLangArray = [];
    var selectedTargetLangArray = [];
    getAxiosResponse(APIUrls.GET_ACCOUNT_SOURCE_LANGUAGES)
      .then((res) => {
        if (res.data !== "") {
          res.data.data.map((langs) => {
            defaultSelectedSourceLangArray.push({
              label: langs.display,
              value: langs.code,
              language: langs.language,
              langData: langs,
            });
          });
          setDefaultSelectedSourceLanguages(defaultSelectedSourceLangArray);
          let results = [];
          results = allLanguages.filter(
            ({ language: id1 }) =>
              !res.data.data.some(({ language: id2 }) => id2 === id1)
          );

          results.map((langs) => {
            selectedSourceLangArray.push({
              label: langs.display,
              value: langs.code,
              language: langs.language,
              langData: langs,
            });
          });

          setSourceLanguages(selectedSourceLangArray);
        }
      })
      .catch((err) => {
        console.error(err);
      });

    getAxiosResponse(APIUrls.GET_ACCOUNT_TARGET_LANGUAGES)
      .then((res) => {
        if (res.data !== "") {
          res.data.data.map((langs) => {
            defaultSelectedTargetLangArray.push({
              label: langs.display,
              value: langs.code,
              language: langs.language,
              langData: langs,
            });
          });

          setDefaultSelectedTargetLanguages(defaultSelectedTargetLangArray);
          let targetResults = [];
          targetResults = allLanguages.filter(
            ({ language: id1 }) =>
              !defaultSelectedTargetLangArray.some(({ language: id2 }) => id2 === id1)
          );

          targetResults.map((langs) => {
            selectedTargetLangArray.push({
              label: langs.display,
              value: langs.code,
              language: langs.language,
              langData: langs,
            });
          });

          setTargetLanguages(selectedTargetLangArray);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }, [allLanguages]);

  const handleSourceLanguageChange = (event) => {
    var selectedLang = event;
    var langArray = [];
    langArray.push(event);
    setDefaultSelectedSourceLanguages((current) => {
      const updatedArray = [...current, event];
      return updatedArray.sort((a, b) => a?.label?.localeCompare(b?.label));
    });
    setSelectedSourceLanguage(selectedLang);
    var result = sourceLanguages.filter(
      ({ language: id1 }) => !langArray.some(({ language: id2 }) => id2 === id1)
    );
    setSourceLanguages(result);
    enableSave();
    setTimeout(function(){
      $('.lang-first div button').removeClass('lastFocus');
     }, 900)
     setTimeout(function(){
      $('.lang-first div:last button').addClass('lastFocus');
     }, 1000)
  };

  const handleTargetLanguageChange = (event) => {
    var selectedLang = event;
    var langArray = [];
    langArray.push(event);
    setSelectedTargetLanguage(selectedLang);
    setDefaultSelectedTargetLanguages((current) => {
      const updatedArray = [...current, event];
      return updatedArray.sort((a, b) => a?.label?.localeCompare(b?.label));
    });
    enableSave();
    var result = targetLanguages.filter(
      ({ language: id1 }) => !langArray.some(({ language: id2 }) => id2 === id1)
    );
   setTimeout(function(){
    $('.lang-second div button').removeClass('lastFocus');
   }, 900)
   setTimeout(function(){
    $('.lang-second div:last button').addClass('lastFocus');
   }, 1000)
    setTargetLanguages(result);
  };

  const removeSourceLanguage = (selected) => {
    var langArray = [];
    langArray.push(selected);
    var oldSourceArray = sourceLanguages;
    var result = defaultSelectedSourceLanguages.filter(
      ({ language: id1 }) => !langArray.some(({ language: id2 }) => id2 === id1)
    );
    setSelectedSourceLanguage(result);
    setDefaultSelectedSourceLanguages(result);
    oldSourceArray.push(selected);
    oldSourceArray.sort((a,b)=>a.language.localeCompare(b.language));
    setSourceLanguages(oldSourceArray);
    enableSave();
    if($('.lang-first div').length <= 1){
       $('.stricy-btn .left div:last button').trigger("focus");
    }
  };

  const removeTargetLanguage = (selected) =>{
    var langArray = [];
    langArray.push(selected);
    var oldTargertArray = targetLanguages;
    var result = defaultSelectedTargetLanguages.filter(
      ({ language: id1 }) => !langArray.some(({ language: id2 }) => id2 === id1)
    );
    setSelectedTargetLanguage(result);
    setDefaultSelectedTargetLanguages(result)
    oldTargertArray.push(selected);
    oldTargertArray.sort((a,b)=>a.language.localeCompare(b.language));
    setTargetLanguages(oldTargertArray);
    enableSave();
    if($('.lang-second div').length <= 1){
      $('.stricy-btn .left div:last button').trigger("focus");
    }
  }
  $('.lang-second div:last button, .lang-first div:last button').addClass('lastFocus');
  $(document).on("click",".lastFocus",function() {
    $('.stricy-btn .left div:last button').trigger("focus");
 });
 
  const saveLanguageDetail = () => {
    var sourceLanguages = []
    var targetLanguages = []
    defaultSelectedSourceLanguages.map((source)=>{
      sourceLanguages.push(source.langData.language)
    })
    defaultSelectedTargetLanguages.map((source)=>{
      targetLanguages.push(source.langData.language)
    })
    postAxiosResponse(APIUrls.GET_ALL_LANGUAGES, {
      'sourceLanguages': sourceLanguages,
      'targetLanguages': targetLanguages,
    }).then((res) => {
      setSuccessMessage("Settings updated successfully.");
      getData();
      disbaleSave();
    }).catch((err) => {
      console.error(err);
    });
  };

  const crumbs = [
    {label:'Settings', url:'settings'},
    {label:'Languages', url:''},
  ];

  const enableSave = ()=>{
    const saveBtn = $("#save-btn");
    if(saveBtn.hasClass("disabled-btn")){
      saveBtn.removeClass("disabled-btn");
    }
  };

  const disbaleSave = ()=>{
    const saveBtn = $("#save-btn");
    if(!saveBtn.hasClass("disabled-btn")){
      saveBtn.addClass("disabled-btn");
    }
  }

  useEffect(()=>{
   if(defaultSelectedSourceLanguages.length ===0 || defaultSelectedTargetLanguages.length ===0 ){
     disbaleSave();
   }
  },[defaultSelectedSourceLanguages,defaultSelectedTargetLanguages]);
 
  return (
    <>
      <div className="body bg-color">
        <div id="container" className="dashboard-wrapper">
          <Header ref={scrollRef} />
          <LeftNavbar />
          <section className="dashboard-content" ref={scrollRef}>
            <div id="content" className="dashboard-wrap">
              <Breadcrumb crumbs={ crumbs } />
              <div className="project-setting-page">
                <div className="project-heading userprofile-heading">
                  <div className="back-arrow flex-center" >
                    <button  onClick={() => navigate("/settings")} aria-label="back" >
                      <svg xmlns="http://www.w3.org/2000/svg"  width="14" height="13" viewBox="0 0 14 13" fill="none" >
                        <path d="M0.46967 5.96967C0.176777 6.26256 0.176777 6.73744 0.46967 7.03033L5.24264 11.8033C5.53553 12.0962 6.01041 12.0962 6.3033 11.8033C6.59619 11.5104 6.59619 11.0355 6.3033 10.7426L2.06066 6.5L6.3033 2.25736C6.59619 1.96447 6.59619 1.48959 6.3033 1.1967C6.01041 0.903806 5.53553 0.903806 5.24264 1.1967L0.46967 5.96967ZM1 7.25H14V5.75H1V7.25Z"
                          fill="#1D4ED8" />
                      </svg>
                    </button>
                    <span>Back to Settings</span>
                  </div>
                  <h3 className="flex">
                    {translate("settings.languages_available")}                 
                  </h3>
                  <span>
                    Selections available for target and source languages on
                    projects.
                  </span>
                </div>
                <div className="white-bg">
                  <div className="setting-language flex">
                    <div className="left">
                      <div className="mar-bot14">
                        <h6>Source Languages</h6>
                        <small>You translate from these languages</small>
                      </div>
                      <div className="flex wrap-dropdown mb-0">
                        <div className="global-dropdown-block flex-center">
                          <div className="global-dropdown-select">
                            <Select classNamePrefix='cw'
                              className="global-dropdown-select"
                              value={sourceLanguages.filter(function (option) {
                                return option.langData === selectedSourceLanguage;
                              })}
                              aria-label="Source Languages"
                              options={sourceLanguages}
                              onChange={(e) => handleSourceLanguageChange(e)}
                              menuShouldScrollIntoView={false}
                              closeMenuOnSelect={true} 
                              />
                          </div>
                        </div>
                      </div>
                      <div className="multiselect-output lang-first flex flex-column">
                        {defaultSelectedSourceLanguages.map(
                          (defaultSelected, index) => {
                            return (
                              <div key={index}>
                                <button onClick={()=>removeSourceLanguage(defaultSelected)} aria-label={"remove " + defaultSelected.label}>
                                  <strong>{defaultSelected.label}</strong>
                                  {CrossIcon}
                                </button>
                              </div>
                            );
                          }
                        )}
                      </div>
                    </div>
                    <div className="left">
                      <div className="mar-bot14">
                        <h6>Target Languages</h6>
                        <small>You translate into these languages</small>
                      </div>
                      <div className="flex wrap-dropdown mb-0">
                        <div className="global-dropdown-block flex-center">
                          <div className="global-dropdown-select">
                            <Select classNamePrefix='cw'
                              className="global-dropdown-select"
                              value={targetLanguages.filter(function (option) {
                                return option.code === selectedTargetLanguage;
                              })}
                              aria-label="Target Languages"
                              options={targetLanguages}
                              onChange={(e) => handleTargetLanguageChange(e)}
                              menuShouldScrollIntoView={false}
                              closeMenuOnSelect={true} 
                            />
                          </div>
                        </div>
                      </div>
                      <div className="multiselect-output lang-second flex flex-column">
                        {defaultSelectedTargetLanguages.map(
                          (defaultSelected, targetIndex) => {
                            return (
                              <div key={targetIndex} className="selectedLangs">
                                <button onClick={()=>removeTargetLanguage(defaultSelected)} aria-label={"remove " + defaultSelected.label}>
                                  <strong>{defaultSelected.label}</strong>
                                  {CrossIcon}
                                </button>
                              </div>
                            );
                          }
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>

        <div className="stricy-btn flex flex-center no-rightlist justify-end">
          <div className="left flex">
            <div>
              <button className="btn-default" onClick={() => navigate("/settings")}>Cancel</button>
            </div>
            <div>
              <button  id="save-btn" className="btn-default disabled-btn" onClick={saveLanguageDetail}>Save</button>
            </div>
          </div>
        </div>
      </div>
      {successMessage !== undefined && successMessage !== Constants.BLANK ? (
        <SuccessMessage message={successMessage} />
      ) : (
        Constants.BLANK
      )}
    </>
  );
}
